import {
  types,
  IGetPublishingLocationsAction,
  IGetPublishingLocationsSuccessAction,
  IPublishingLocation,
  IFailureAction,
} from '../types/publishingLocations'

export const getPublishingLocations = (): IGetPublishingLocationsAction => ({
  type: types.GET_PUBLISHING_LOCATIONS__STARTED,
})

export const getPublishingLocationsSuccess = (
  list: IPublishingLocation[]
): IGetPublishingLocationsSuccessAction => ({
  type: types.GET_PUBLISHING_LOCATIONS__SUCCESS,
  list,
})

export const getPublishingLocationsFailure = (
  message: string
): IFailureAction => ({
  type: types.GET_PUBLISHING_LOCATIONS__FAILURE,
  message,
})
